import React, { useCallback, useEffect, useRef, useState } from 'react';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
import { downloadFile } from '../../../../../shared/utils/download';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { Notification } from '../../../../../shared/components/Notifications/interface';
import FormularioAdjuntarContainer from '../Adjuntos/container';
import FormularioEditarPartes from './editar';
import FormularioUploadContainer from '../UploadFile/container';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { FormularioCrearPartesFinSemana } from './crearFinSemana';
import { FormularioEditarPartesFinSemana } from './editarFinSemana';
import { EuiBadge, EuiButton, EuiFlexGroup, EuiFlexItem, EuiFlyout, EuiFlyoutBody, EuiFlyoutFooter, EuiFlyoutHeader, EuiModal, EuiModalBody, EuiModalHeader, EuiModalHeaderTitle, EuiOverlayMask } from '@elastic/eui';
import { FormularioCrearPartes } from './crear';
import { PanelInfoBloqueoApp } from '../../../components/Layout/PanelInformativoBloqueo';
import './styles.css';

export const FormularioContainer = (props: any) => {

	let { tipo, title, handle, esDelegado, selected, onClose,user, userConnect } = props;
	const {resultError, exceptionError, launchNotification} = useNotifications();
	const api = new AdjuntosAdapter();

	let [refreshAdjuntos,setRefreshAdjuntos] = useState(false);
	let ref:any = useRef();
	let notification: Notification;
	let result: any;

	useEffect(()=>{setRefreshAdjuntos(false);},[props])

	const onCreate = async (parte: any, adjuntos: any) => {
		if (handle) {
		const isWeekEnd = (tipo === 'IFS');
		 handle(parte, adjuntos, isWeekEnd);
		}
	};

	const onUpdate = async (parte: any) => {
		if (handle) {
			const isWeekEnd = (tipo === 'UFS');
			handle(parte,refreshAdjuntos,isWeekEnd);
		}
	};

	const onAdjuntar = async (data: any) => {
		if (handle) {
			setRefreshAdjuntos(false);
			handle(data);
		}
	};

	const onDownLoadAdjuntos = async(idAdjunto: number, nombre: string) =>{
    //const api = new AdjuntosAdapter();
    try {
			result = await api.DescargarAdjunto(idAdjunto);
			if(result.data && result.data!=="")
			{
				await downloadFile(result.data,nombre)
				setRefreshAdjuntos(false);
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
      exceptionError(exception);
		}
	}
	
	const onRemoveAdjuntos = async(data: any, errorDesplazado?: boolean) =>{
		// eslint-disable-next-line no-restricted-globals
		if(errorDesplazado)
		{
			notification={type:"warning",title:"Eliminar Adjunto(s)",message:'No se pueden eliminar más adjuntos. Con la opción desplazado/a debe de haber al menos un adjunto.'}
			launchNotification(notification,false)
		}
		else{
			try {
					result = await api.EliminarAdjuntos(data);
					
					if(result.data && result.data!=="")
					{
						notification={type:"success",title:"Eliminar Adjunto(s)",message:(data.todosPartes ? "Se ha eliminado el adjunto para todos los partes." : "Se ha eliminado el adjunto para el parte.")}
						launchNotification(notification)
						setRefreshAdjuntos(result.data);
						return result.data;
					}else{resultError()}
				} catch (e) {
					let exception = ServerErrorMessage(e);
					exceptionError(exception)
				}
		}
  	}

	const onChangeTypeAdjunto = async(dataAdjunto:any) =>{
		try {
			result = await api.ModificarTipoAdjunto(dataAdjunto);
			if(result.data && result.data!=="")
			{
				launchNotification({type:"success",title:"Modificación Adjunto",message:"Se ha modificado un adjunto."})
				setRefreshAdjuntos(true);
			}else{resultError()}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
	}

	const onSaveForm = ()=>{
		ref.current && ref.current.onSaveDataForm()
	}

	const badgesStateFacturado = useCallback(()=>{
		return (tipo === 'U' && (selected&&selected.facturado))?
		<EuiFlexItem grow={false}>
		  <EuiBadge color="#b0ffb2"><h2>{`Parte Facturado`}</h2></EuiBadge>
		</EuiFlexItem>
		:null
	  },[tipo,selected])
	
	  const badgesStateValidado = useCallback(()=>{
		return (tipo === 'U' && (selected&&selected.estado > 1))?
		<EuiFlexItem grow={false}>
		  <EuiBadge color="#cfcaf7"><h2>{`Parte Validado`}</h2></EuiBadge>
		</EuiFlexItem>
		:null
	  },[tipo,selected])

	  const badgeDelegado = useCallback(()=>{
		return esDelegado ? 
			<EuiFlexItem grow={false}>
			<EuiBadge className='badgeTitleModal'><h2>{`${(user&&user.nombre.toLowerCase().charAt(0).toUpperCase()) + (user&&user.nombre.toLowerCase().slice(1))}`}</h2></EuiBadge>
	  		</EuiFlexItem>
	  	:null
	  },[esDelegado])

	//FORMULARIOS
	const FORMULARIO = ()=>{
		switch (tipo) {
			case 'I': //INSERTAR SOLO DIAS LABORABLES
				return <FormularioCrearPartes {...{onSave:onCreate,user:(userConnect.login ===user.login?userConnect:user)}} ref={ref}/>;
			case 'IFS': //INSERTAR SOLO FIN DE SEMANA
				return <FormularioCrearPartesFinSemana {...{onSave:onCreate,user:(userConnect.login ===user.login?userConnect:user)}} ref={ref}/>
			case 'U': //EDITAR SOLO DIAS LABORABLES
				return <FormularioEditarPartes 
				{...{onSave:onUpdate,user:(userConnect.login ===user.login?userConnect:user),onDownLoad:onDownLoadAdjuntos,
					onRemoveAdjuntos:onRemoveAdjuntos, handleChangeTypeAdjunto:onChangeTypeAdjunto, selected:selected, refreshAdjuntos:refreshAdjuntos
				}} ref={ref}/>;
			case 'UFS': //EDITAR SOLO FIN DE SEMANA
				return <FormularioEditarPartesFinSemana 
				{...{onSave:onUpdate,user:(userConnect.login ===user.login?userConnect:user),onDownLoad:onDownLoadAdjuntos,
					onRemoveAdjuntos:onRemoveAdjuntos, handleChangeTypeAdjunto:onChangeTypeAdjunto, selected:selected, refreshAdjuntos:refreshAdjuntos
				}} ref={ref}/>
			case 'A': //ADJUNTAR
				return <FormularioAdjuntarContainer handle={onAdjuntar}  selected={selected} onClose={onClose}/>;
			case 'UF': //IMPORTAR PARTES DESDE EXCEL
				return <FormularioUploadContainer handle={handle} selected={selected} onClose={onClose}/>;
			default: return null;
		}
	}

	const getFlyout = () =>(
		<EuiFlyout onClose={onClose} size='l'>
        <EuiFlyoutHeader hasBorder>
          <EuiFlexGroup alignItems='center'>
              <EuiFlexItem grow={false}>
                {`${title}`}
              </EuiFlexItem>
              {badgeDelegado()}
              {badgesStateFacturado()}
              {badgesStateValidado()}
          </EuiFlexGroup>
          </EuiFlyoutHeader>
          <EuiFlyoutBody>
            {/* <PanelInfoBloqueoApp/> */}
			{FORMULARIO()}
          </EuiFlyoutBody>
          	<EuiFlyoutFooter>
				<EuiFlexGroup>
				<EuiFlexItem>
					<EuiButton color="danger" onClick={onClose}>{`Cancelar`}</EuiButton>
				</EuiFlexItem>
				<EuiFlexItem>
					<EuiButton onClick={()=>{onSaveForm()}} fill>{`Guardar`}</EuiButton>
				</EuiFlexItem>
				</EuiFlexGroup>
        	</EuiFlyoutFooter>
      </EuiFlyout>
	)

	const getModal = ()=>(
		<EuiOverlayMask  headerZindexLocation='above'>
			<EuiModal onClose={onClose}  maxWidth={false}>
				<EuiModalHeader>
					<EuiModalHeaderTitle>
						<EuiFlexGroup alignItems='center'>
						<EuiFlexItem grow={false}>
							{`${title}`}
						</EuiFlexItem>
						{badgeDelegado()}
						{badgesStateFacturado()}
						{badgesStateValidado()}
						</EuiFlexGroup>
					</EuiModalHeaderTitle>
				</EuiModalHeader>
				<EuiModalBody style={{minWidth:'65vw'}}>
				{tipo === 'UF' ? <PanelInfoBloqueoApp/> : null}
				{FORMULARIO()}
				</EuiModalBody>
			</EuiModal>
	  </EuiOverlayMask>
	)

	return (tipo === 'A' || tipo === 'UF') ? getModal() : getFlyout();
};

export default FormularioContainer;